import { useSession, useUser } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

// Attaches the signed-in Clerk user + session to Sentry events so errors are
// traceable to a person, and clears that context on sign-out. Renders nothing.
export function SentryUser(): null {
  const { user } = useUser();
  const { session } = useSession();

  useEffect(() => {
    if (!user) {
      Sentry.setUser(null);
      return;
    }

    Sentry.setUser({
      id: user.id,
      email: user.primaryEmailAddress?.emailAddress,
    });
    Sentry.setTag('session.id', session?.id);
  }, [user, session]);

  return null;
}
